"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _glutenFree = _interopRequireDefault(require("./gluten-free.png"));
var _vegetarian = _interopRequireDefault(require("./vegetarian.png"));
var labels = {
  'Gluten Free': _glutenFree["default"],
  Vegetarian: _vegetarian["default"]
};
var _default = labels;
exports["default"] = _default;